import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

import { LocalStorageService } from "src/app/utils/localstorage.service";
import { environment } from "../../../../environments/environment";
import { Observable, Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class ClientService {
  headers = new Headers();
  switchTabSubject = new Subject();

  constructor(
    private http: HttpClient,
    private localStorage: LocalStorageService,
    private router: Router
  ) {}

  get_company_info(): Promise<any> {
    return this.http.get(`${environment.apiUrl}/company/`).toPromise();
  }
}
